<template>
  <!-- https://nuxt.com/docs/4.x/api/components/nuxt-route-announcer -->
  <!-- 可展示获取页面标题 -->
  <!-- <NuxtRouteAnnouncer /> -->
  <!-- 顶栏 -->
  <CommonNavBar />
  <!-- 页面容器 -->
  <UMain
    :ui="{
      base: [
        // 让容器的高度可以塌陷
        'min-h-0',
      ],
    }"
  >
    <slot />
    <!-- cookie弹窗 -->
    <!-- <DialogAllowCookie /> -->
    <!-- 页面右侧底部回顶按钮组 -->
    <CommonToolBox />
  </UMain>
  <!-- 页脚 -->
  <CommonFooter />
</template>

<script lang="ts" setup></script>
